import { TLD, StringMap, Page } from '@packages/common';

const frSalesStart = new Date('06/30/2021');
const frSalesEnd = new Date('07/27/2021');
const now = new Date();
const isSalesInFr = now >= frSalesStart && now < frSalesEnd;

export const inspirationItems = {
  [TLD.DE]: [
    {
      title: 'Ratgeber',
      href: Page.contentful,
      as: '/magazin/ratgeber',
      mobileOnly: true,
    },
    {
      title: 'Do it yourself',
      href: Page.contentful,
      as: '/magazin/diy',
      mobileOnly: true,
    },
    {
      title: 'Shop the look',
      href: Page.contentful,
      as: '/magazin/shopthelook',
      mobileOnly: true,
    },
    {
      title: 'Trends',
      href: Page.contentful,
      as: '/magazin/trends',
      mobileOnly: true,
    },
    {
      title: 'Sale',
      href: Page.contentful,
      as: '/sale',
      emphesize: true,
      mobileOnly: false,
    },
    {
      title: 'Marken',
      href: Page.contentful,
      as: '/marken',
      mobileOnly: false,
    },
  ],
  [TLD.FR]: [
    {
      title: isSalesInFr ? 'Soldes' : 'Promos',
      href: Page.contentful,
      as: '/promotions',
      emphesize: true,
      mobileOnly: false,
    },
    {
      title: 'Inspiration',
      href: Page.contentful,
      as: '/magazine',
      mobileOnly: false,
    },
    {
      title: 'Marques',
      href: Page.contentful,
      as: '/marques',
      mobileOnly: false,
    },
  ],
  [TLD.NL]: [
    {
      title: 'Sale',
      href: Page.contentful,
      as: '/sale',
      emphesize: true,
      mobileOnly: false,
    },
    {
      title: 'Magazine',
      href: Page.contentful,
      as: '/magazine',
      mobileOnly: false,
    },
    {
      title: 'Merken',
      href: Page.contentful,
      as: '/merken',
      mobileOnly: false,
    },
  ],
};

type MobileNavigationTab = {
  id: string;
  title: string;
  href?: Page;
  as?: string;
};

export const getMobileNavigationTabs = (routes: StringMap<Page>, currentTld: TLD): MobileNavigationTab[] => {
  const tabsByTld = {
    [TLD.DE]: [
      {
        title: 'Sortiment',
        id: 'sortiment',
      },
      {
        title: 'Inspiration',
        id: 'inspiration',
      },
      {
        title: 'Lokale Suche',
        id: 'localSearch',
        href: Page.localDealers,
        as: routes[Page.localDealers],
      },
    ],
    [TLD.FR]: [
      {
        title: 'Catégories',
        id: 'sortiment',
      },
      {
        title: 'Inspiration',
        id: 'inspiration',
      },
      {
        id: 'localSearch',
        title: 'Magasins',
        href: Page.localDealers,
        as: routes[Page.localDealers],
      },
    ],
    [TLD.NL]: [
      {
        title: 'Assortiment',
        id: 'sortiment',
      },
      {
        title: 'Inspiratie',
        id: 'inspiration',
      },
    ],
  };
  return tabsByTld[currentTld];
};

export const getInspirationItems = (currentTld: TLD) => {
  return inspirationItems[currentTld];
};
